import classNames from 'classnames';

import { type NotificationBoard as NotificationBoardType } from '@air/api/types';

import BoardThumbnail from '~/components/BoardThumbnail/BoardThumbnail';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

const NOTIFICATION_BOARD_THUMBNAIL_SIZE = 56;
const UI2026_NOTIFICATION_BOARD_THUMBNAIL_SIZE = 40;

export type NotificationBoardProps = {
  board: NotificationBoardType;
};

export const NotificationBoard = ({ board }: NotificationBoardProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();
  const thumbnailSize = ui2026 ? UI2026_NOTIFICATION_BOARD_THUMBNAIL_SIZE : NOTIFICATION_BOARD_THUMBNAIL_SIZE;

  return (
    <div
      className={classNames(
        'relative flex ui2026:size-10 h-14 w-14 items-center justify-center overflow-hidden rounded-4 ui2026:rounded-8',
      )}
    >
      <BoardThumbnail
        board={board}
        width={thumbnailSize}
        height={thumbnailSize}
        sizes={String(thumbnailSize)}
        objectFit="cover"
        className="![&>img]:h-[inherit]"
      />
    </div>
  );
};
